import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

import { isMobileMedia } from 'bento-ordering/utils/media';
import {
  ITEM_DESCRIPTION_AND_PRICES,
  MENU_ITEM_NAMES
} from 'styles/constants/appearanceSectionNames';
import {
  SNACKBAR_TITLE,
  SNACKBAR_RE_OPEN_MESSAGE,
  SNACKBAR_DEFAULT_MESSAGE
} from 'constants/previewMenu';
import { getCurentLocationReopenStoreAtFieldSelector } from 'bento-ordering/locations/selectors';
import { formatDateTime } from 'bento-ordering/base/utils/timeHelpers';
import {
  SnackbarTitle,
  SnackbarMessage
} from 'bento-ordering/base/components/Snackbar/SnackbarTypography';
import AlertSnackbar from 'bento-ordering/base/components/Snackbar/AlertSnackbar';

const Message = ({ reopenStoreAt }) => {
  const titleStyles = { variant: MENU_ITEM_NAMES };
  const messageStyles = { variant: ITEM_DESCRIPTION_AND_PRICES };

  return (
    <span>
      <Box pb={1}>
        <SnackbarTitle component="p" {...titleStyles}>
          {SNACKBAR_TITLE}
        </SnackbarTitle>
      </Box>
      <SnackbarMessage component="p" {...messageStyles}>
        {reopenStoreAt
          ? `${SNACKBAR_RE_OPEN_MESSAGE} ${formatDateTime(reopenStoreAt)}.`
          : SNACKBAR_DEFAULT_MESSAGE}
      </SnackbarMessage>
    </span>
  );
};

Message.propTypes = {
  reopenStoreAt: PropTypes.string
};

const OrderingNotCurrentlyAvailableSnackbar = ({ open }) => {
  const reopenStoreAt = useSelector(
    getCurentLocationReopenStoreAtFieldSelector
  );

  return (
    <AlertSnackbar
      open={open}
      message={Message({ reopenStoreAt })}
      vertical={isMobileMedia() ? 'bottom' : 'top'}
    />
  );
};

OrderingNotCurrentlyAvailableSnackbar.propTypes = {
  open: PropTypes.bool
};

OrderingNotCurrentlyAvailableSnackbar.defaultProps = {
  open: false
};

export default OrderingNotCurrentlyAvailableSnackbar;
